<template>
  <div style="width: 100%;">
    <div class="shopSearchResult">
      <div class="ui vertical loader" :class="{active: waiting && shops.length === 0}"></div>
      <slot name="banner" />
      <div v-show="!waiting" class="shopSearchResult__resultNumberContainer">
        宴会・パーティー会場検索結果<span class="shopSearchResult__resultNumber">{{ pager.total }}</span>件
      </div>
      <div v-show="!waiting" class="shopSearchResult__selectionListContainer">
        <div class="shopSearchResult__selectionListTitle">
          まとめて問い合わせリスト <span class="count">{{ $root.selectedShopCount }}</span> 件
        </div>
        <div class="shopSearchResult__selectionListHint">（最大10件選択可能です）</div>
      </div>

      <div class="shopSearchResult__shopList">
        <search-result-shop :shops="pr_shops" :is-promotion="true"></search-result-shop>
        <search-result-shop :shops="filteredShops"></search-result-shop>
      </div>
    </div>
    <front-pagination v-show="!waiting" :pager="pager" :form="form" />
  </div>
</template>

<script>
import ShopSearchResultCheckbox from './shopSearchResultCheckbox.vue';
import ShopSearchResultHeaderCheckbox from "./shopSearchResultHeaderCheckbox.vue";
import FrontPagination from "./frontPagination.vue";
import SearchResultShop from "./searchResultShop.vue";

export default {
    components: {
        'shop-search-result-checkbox': ShopSearchResultCheckbox,
        'shop-search-result-header-checkbox': ShopSearchResultHeaderCheckbox,
        'front-pagination': FrontPagination,
        'search-result-shop': SearchResultShop,
    },
    props: {
        pager: {
            required: true
        },
        shops: {
            required: true
        },
        pr_shops: {
            required: true,
        },
        waiting: {
            required: true,
            type: Boolean
        },
        form: {
          required: false,
        },
    },
    mounted() {
        this.$emit('next', this.pager.current());
    },
    computed: {
        filteredShops() {
            const prShopIds = this.pr_shops.map(shop => shop.id);
            return this.shops.filter(shop => !prShopIds.includes(shop.id));
        },
    },
};
</script>
